import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';
import { Button } from './ui/button';
import { Copy, Loader2 } from 'lucide-react';

/** Admin report of merchants that look like duplicates (same business name or mobile). */
export function DuplicateMerchantsDialog({ api }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get('/api/admin/merchants/duplicates').then(({ data: d }) => setData(d)).catch(() => setData({ groups: [], count: 0 })); }, [api]);
  if (!data) return null;
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className={data.count ? 'border-[#FF9100]/40 text-[#FF9100] hover:bg-[#FF9100]/10' : 'border-white/15 text-[#A0B4CC]'} data-testid="duplicate-merchants-btn">
          <Copy className="w-4 h-4 mr-2" />Duplicates ({data.count})
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-[#041A3B] border-white/10 text-white max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="duplicate-merchants-dialog">
        <DialogHeader><DialogTitle>Possible duplicate merchants</DialogTitle></DialogHeader>
        <p className="text-xs text-[#A0B4CC]">Duplicates make the Marketplace look unreliable. Keep the most complete profile and delete or ban the others from the Merchants list.</p>
        {data.groups.length === 0 && <p className="text-sm text-[#5C7599] py-6 text-center" data-testid="duplicate-merchants-empty">No duplicates found.</p>}
        <div className="space-y-3">
          {data.groups.map((g, i) => (
            <div key={i} className="rounded-lg border border-white/10 p-3" data-testid={`duplicate-group-${i}`}>
              <p className="text-[10px] uppercase tracking-wider text-[#FF9100] mb-2">Same {g.match === 'name' ? 'business name' : 'mobile number'}</p>
              {g.merchants.map((m) => (
                <div key={m.id} className="flex items-center justify-between gap-3 py-1.5 border-t border-white/5 first:border-0 text-sm">
                  <div className="min-w-0">
                    <p className="truncate">{m.merchant_info?.business_name || m.name}</p>
                    <p className="text-xs text-[#5C7599] truncate">{m.email} · {m.mobile || 'no mobile'} · {m.merchant_status} · {String(m.created_at || '').slice(0, 10)}</p>
                  </div>
                  <Link to={`/marketplace/${m.id}`} target="_blank" className="text-xs text-[#00E5FF] flex-shrink-0">View</Link>
                </div>
              ))}
            </div>
          ))}
        </div>
        {!data && <Loader2 className="w-5 h-5 animate-spin" />}
      </DialogContent>
    </Dialog>
  );
}
